module.exports = __webpack_public_path__ + "static/image6-8104586d99824445920e0715c7c9413a.jpeg";